import ApiEndPoints from '@/services/common/api/apiEndPoints';

export default class ApiEndPointsBuilder {
  static validateActivateAccountToken(emailConfirmationToken) {
    return `${ApiEndPoints.activateAccount}?token=${emailConfirmationToken}`;
  }

  static validateResetPasswordToken(resetPasswordToken) {
    return `${ApiEndPoints.account}/passwords/requests/reset?resetPasswordToken=${resetPasswordToken}`;
  }

  static purchaseOrderDetails(purchaseOrderNumber) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}`;
  }

  static purchaseOrderShippingInfo(purchaseOrderNumber) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}/shippingInfo`;
  }

  static purchaseOrderDetailsExists(purchaseOrderNumber) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}/exists`;
  }

  static purchaseOrderLineItemUploadedImages(purchaseOrderNumber, lineItemId) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}/lineItems/${lineItemId}/images/uploaded`;
  }

  static purchaseOrderLineItemApprovedImages(purchaseOrderNumber, lineItemId) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}/lineItems/${lineItemId}/images/approved`;
  }

  static purchaseOrderLineItemActivity(purchaseOrderNumber, lineItemId) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}/lineItems/${lineItemId}/activities`;
  }

  static uploadLineItemImages(purchaseOrderNumber, lineItemId, sku) {
    return `${ApiEndPoints.uploads}/purchaseOrders/${purchaseOrderNumber}/lineItems/${lineItemId}/sku/${sku}/images`;
  }

  static uploadLineItemsImages(purchaseOrderNumber) {
    return `${ApiEndPoints.uploads}/purchaseOrders/${purchaseOrderNumber}/lineItems/images`;
  }

  static poLineItemsStatusTransition(purchaseOrderNumber) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}/lineItems/update/status`;
  }

  static poLineItemsReportIssue(purchaseOrderNumber) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}/lineItems/issues/report`;
  }

  static poLineItemsComment(purchaseOrderNumber) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}/lineItems/comment`;
  }

  static deleteLineItemCommentMultiple(purchaseOrderNumber) {
    return `${ApiEndPoints.purchaseOrders}/purchaseOrders/${purchaseOrderNumber}/lineItems/comments/delete`;
  }

  static getApprovalDocument(purchaseOrderNumber) {
    return `${ApiEndPoints.pdf}/purchaseOrders/${purchaseOrderNumber}/approval`;
  }

  static updateEmployee(employeeId) {
    return `${ApiEndPoints.employees}/${employeeId}`;
  }

  static updateSupplier(supplierId) {
    return `${ApiEndPoints.suppliers}/${supplierId}`;
  }

  static deleteLineItemImage(purchaseOrderNumber, lineItemId, sku, imageId) {
    const root = ApiEndPoints.uploads;
    return `${root}/purchaseOrders/${purchaseOrderNumber}/lineItems/${lineItemId}/sku/${sku}/images/${imageId}`;
  }

  static deleteLineItemImageMultiple(purchaseOrderNumber) {
    return `${ApiEndPoints.uploads}/purchaseOrders/${purchaseOrderNumber}/lineItems/images/delete`;
  }

  static resendSupplierEmailVerification(userId) {
    return `${ApiEndPoints.suppliers}/${userId}/verifications/resend`;
  }

  static resendEmployeeEmailVerification(userId) {
    return `${ApiEndPoints.employees}/${userId}/verifications/resend`;
  }

  static subordinatesInfo(userId) {
    return `${ApiEndPoints.subordinates}/${userId}/workload`;
  }

  static subordinatesUpdateSubscription(userId) {
    return `${ApiEndPoints.subordinates}/${userId}/updateSubscription`;
  }

  static canAddComment(purchaseOrderNumber, lineItemId) {
    return `${ApiEndPoints.purchaseOrders}/${purchaseOrderNumber}/lineItems/${lineItemId}/canaddcomment`;
  }

  static getPrintLabel(printLabelId) {
    return `${ApiEndPoints.printLabels}/get/${printLabelId}`;
  }

  static addPrintLabel() {
    return `${ApiEndPoints.printLabels}/add`;
  }
}
